import { ACCESS_DOMAINS, APIMethod, fetchData } from "@client";

export async function storeIssuesBudgetTrackingQuery(data) {
  return await fetchData(`api/export/issues`, APIMethod.POST, {
    baseURL: ACCESS_DOMAINS.btApi,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
}
